// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// Run `yarn run download-resources` to regenerate.
// If you need to update the code, please edit `i18n/src/scripts/download.ts` inside your project.
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import ja from './ja.json';
import ko from './ko.json';
import pt_BR from './pt-BR.json';
import ru from './ru.json';
import zh_Hans from './zh-Hans.json';
import zh_Hant from './zh-Hant.json';

export const LOCALES = [
  {
    id: 1000040010,
    name: 'Korean (South Korea)',
    tag: 'ko',
    originalName: '한국어(대한민국)',
    flagEmoji: '🇰🇷',
    base: false,
    completeRate: 0.26,
    res: ko,
  },
  {
    id: 1000040021,
    name: 'Portuguese (Brazil)',
    tag: 'pt-BR',
    originalName: 'Português (Brasil)',
    flagEmoji: '🇧🇷',
    base: false,
    completeRate: 0.414,
    res: pt_BR,
  },
  {
    id: 1000040001,
    name: 'English',
    tag: 'en',
    originalName: 'English',
    flagEmoji: '🇬🇧',
    base: true,
    completeRate: 0.969,
    res: en,
  },
  {
    id: 1000040003,
    name: 'Traditional Chinese',
    tag: 'zh-Hant',
    originalName: '繁體中文',
    flagEmoji: '🇭🇰',
    base: false,
    completeRate: 0.506,
    res: zh_Hant,
  },
  {
    id: 1000040004,
    name: 'Simplified Chinese',
    tag: 'zh-Hans',
    originalName: '简体中文',
    flagEmoji: '🇨🇳',
    base: false,
    completeRate: 0.972,
    res: zh_Hans,
  },
  {
    id: 1000040006,
    name: 'French',
    tag: 'fr',
    originalName: 'français',
    flagEmoji: '🇫🇷',
    base: false,
    completeRate: 0.861,
    res: fr,
  },
  {
    id: 1000040008,
    name: 'Spanish',
    tag: 'es',
    originalName: 'Español',
    flagEmoji: '🇪🇸',
    base: false,
    completeRate: 0.357,
    res: es,
  },
  {
    id: 1000040009,
    name: 'German',
    tag: 'de',
    originalName: 'Deutsch',
    flagEmoji: '🇩🇪',
    base: false,
    completeRate: 0.354,
    res: de,
  },
  {
    id: 1000040011,
    name: 'Russian',
    tag: 'ru',
    originalName: 'Pусский',
    flagEmoji: '🇷🇺',
    base: false,
    completeRate: 0.445,
    res: ru,
  },
  {
    id: 1000040014,
    name: 'Japanese',
    tag: 'ja',
    originalName: '日本語',
    flagEmoji: '🇯🇵',
    base: false,
    completeRate: 0.279,
    res: ja,
  },
] as const;
